/**
 * @file 获取query
 */

import { useLocation } from 'react-router-dom';

export const useQuery = (key: string) => {
  const search = new URLSearchParams(useLocation().search);
  return search.get(key) || '';
}
